export const animationNames = ['changeWidth', 'changeBorder'];
export const cancelAnimationName = 'cancelAnimation';
export const activatedAnimationName = 'activatedAnimation';
export const delayedAnimationName = 'delayedAnimation';
export const completedAnimationName = 'completedAnimation';
export const aperiodicAnimationName = 'aperiodicAnimation';
export const spontaneousAnimationName = 'spontaneousAnimation';
export const grilledAnimationName = 'grilledAnimation';
export const estimateTagAnimationName = 'estimateTagAnimation';
export const aperiodicEstimateTagAnimationName = 'aperiodicEstimateTagAnimation';
export const spontaneousEstimateTagAnimationName = 'spontaneousEstimateTagAnimation';
export const grilledEstimateTagAnimationName = 'grilledEstimateTagAnimation';
